import { FC } from 'react';
import { Button } from 'react-daisyui';
import { BookOpenIcon } from '@heroicons/react/24/outline';

interface ReadingInsertButtonProps {
  onClick: () => void;
  label?: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'primary' | 'secondary';
  className?: string;
}

const ReadingInsertButton: FC<ReadingInsertButtonProps> = ({
  onClick,
  label = 'View Reading Insert',
  size = 'sm',
  variant = 'secondary',
  className = '',
}) => {
  const buttonClasses =
    variant === 'primary'
      ? 'bg-primary hover:bg-brand-hover text-white'
      : 'text-white-600';

  return (
    <Button
      size={size}
      color={variant === 'secondary' ? 'secondary' : undefined}
      className={`flex items-center gap-2 ${buttonClasses} ${className}`}
      onClick={onClick}
    >
      <BookOpenIcon className="w-5 h-5" />
      {label}
    </Button>
  );
};

export default ReadingInsertButton;
